export const T = {
  en_GB: {
    unknownBucket: "Unknown",
    completeRiskOrBuildCustom:
      "Please complete the risk assessment to see the portfolio analysis, or build a custom portfolio.",
    noProductsXrayPending:
      "No products added yet. Use the Custom Portfolio Builder to add products, then X-Ray analysis will be available.",
    enterInvestmentAmount: "Please enter an investment amount to see the portfolio X-ray.",
    noPortfolioForScore: (score: string) =>
      `No portfolio available for risk score ${score}. Please contact your advisor to see your portfolio X-ray.`,
    xrayNotAvailable:
      "X-Ray analysis data is not available for this portfolio. None of the products have valid ISINs.",
    snapshotMissingMessage:
      "X-Ray analysis needs to be regenerated. Use the Regenerate button above.",
    errorLoadingXray: "Error loading X-ray data. Please refresh the page.",
    xrayUnavailable: "X-Ray Analysis Unavailable",
    noDataForView: "No data available for the selected view.",
    snapshotTaken: (time: string) => `Snapshot taken ${time}`,
    categoryAssetClass: "Asset Class",
    categoryCountry: "Country",
    categoryRegion: "Region",
    categorySector: "Sector",
    categoryStyle: "Style",
    sizeLarge: "Large",
    sizeMid: "Mid",
    sizeSmall: "Small",
    styleValue: "Value",
    styleBlend: "Blend",
    styleGrowth: "Growth",
  },
  nb_NO: {
    unknownBucket: "Ukjent",
    completeRiskOrBuildCustom:
      "Fullfør risikovurderingen for å se porteføljeanalysen, eller bygg en egendefinert portefølje.",
    noProductsXrayPending:
      "Ingen produkter lagt til ennå. Bruk Egendefinert porteføljebygger for å legge til produkter, deretter vil X-Ray-analyse være tilgjengelig.",
    enterInvestmentAmount: "Angi et investeringsbeløp for å se portefølje-X-ray.",
    noPortfolioForScore: (score: string) =>
      `Ingen portefølje tilgjengelig for risikoskår ${score}. Kontakt din rådgiver for å se din portefølje-X-ray.`,
    xrayNotAvailable:
      "X-Ray-analysedata er ikke tilgjengelig for denne porteføljen. Ingen av produktene har gyldige ISIN-er.",
    snapshotMissingMessage: "X-Ray-analyse må regenereres. Bruk Regenerer-knappen over.",
    errorLoadingXray: "Feil ved lasting av X-ray-data. Oppdater siden.",
    xrayUnavailable: "X-Ray-analyse ikke tilgjengelig",
    noDataForView: "Ingen data tilgjengelig for den valgte visningen.",
    snapshotTaken: (time: string) => `Øyeblikksbilde tatt ${time}`,
    categoryAssetClass: "Aktivaklasse",
    categoryCountry: "Land",
    categoryRegion: "Region",
    categorySector: "Sektor",
    categoryStyle: "Stil",
    sizeLarge: "Store",
    sizeMid: "Mellom",
    sizeSmall: "Små",
    styleValue: "Verdi",
    styleBlend: "Blandet",
    styleGrowth: "Vekst",
  },
} as const;
